import ApplicationController from '../application_controller'

export default class IntradayOrderController extends ApplicationController {
  static targets = ['tab', 'button']
  closeModal() {
    this.stimulate('IntradayOrder#close_overview_modal')
  }

  selectTab(event) {
    const selectedTab = this.tabTargets.find(
      (element) => element.id === event.currentTarget.id
    )
    this.tabTargets.forEach((tab) => tab.classList.add('hidden'))
    this.buttonTargets.forEach((button) => {
      button.classList.remove('toggle-active')
      button.classList.add('toggle-inactive')
    })
    selectedTab.classList.remove('hidden')
    event.currentTarget.classList.add('toggle-active')
    event.currentTarget.classList.remove('toggle-inactive')
  }
}
